import getNextClicableEl from './getNextClickableEl';
const handleKeyboardEvent = ({ nodes, activeIndex, setActiveIndex, isFocused }) => (e) => {
    if (!isFocused)
        return;
    switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
        case 'ArrowUp':
        case 'ArrowLeft':
            const direction = e.key === 'ArrowUp' || e.key === 'ArrowRight' ? 'backward' : 'forward';
            const nextEl = getNextClicableEl(nodes, activeIndex, direction);
            if (!nextEl)
                return;
            e.preventDefault();
            e.stopPropagation();
            nextEl.focus();
            setActiveIndex(nodes.indexOf(nextEl));
            break;
        default:
    }
};
export default handleKeyboardEvent;
//# sourceMappingURL=hadnleKeyboardEvent.js.map